/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

const checkout = orderCurrentPaymentData => {
  const paymentData = [
    {
      key: "PaymentId",
      value: orderCurrentPaymentData.PaymentId
    },
    {
      key: "MerchantKey",
      value: orderCurrentPaymentData.MerchantKey
    },
    {
      key: "MerchantCode",
      value: orderCurrentPaymentData.MerchantCode
    },
    {
      key: "RefNo",
      value: orderCurrentPaymentData.RefNo
    },
    {
      key: "Amount",
      value: orderCurrentPaymentData.Amount
    },
    {
      key: "Currency",
      value: orderCurrentPaymentData.Currency
    },
    {
      key: "ProdDesc",
      value: orderCurrentPaymentData.ProdDesc
    },
    {
      key: "Remark",
      value: orderCurrentPaymentData.Remark
    },
    {
      key: "UserName",
      value: orderCurrentPaymentData.UserName
    },
    {
      key: "UserEmail",
      value: orderCurrentPaymentData.UserEmail
    },
    {
      key: "UserContact",
      value: orderCurrentPaymentData.UserContact
    },
    {
      key: "Country",
      value: "MY"
    },
    {
      key: "Lang",
      value: orderCurrentPaymentData.Lang
    },
    {
      key: "SignatureType",
      value: orderCurrentPaymentData.SignatureType
    },
    {
      key: "Signature",
      value: orderCurrentPaymentData.Signature
    },
    {
      key: "BackendURL",
      value: orderCurrentPaymentData.BackendURL
    },
    {
      key: "ResponseURL",
      value: orderCurrentPaymentData.ResponseURL
    }
  ];

  let form = document.createElement("form");
  form.setAttribute("method", "POST");
  form.setAttribute("name", "ePayment");
  form.setAttribute(
    "action",
    "https://payment.ipay88.com.my/epayment/entry.asp"
  );

  paymentData.map((item, index) => {
    let hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", item.key);
    hiddenField.setAttribute("value", item.value);

    form.appendChild(hiddenField);
  });

  document.body.appendChild(form);
  form.submit();
};

export default { checkout };



// WEBPACK FOOTER //
// ./src/utils/IpayHelper.js